/* eslint-disable react/destructuring-assignment */
import { FC } from 'react';

import OrganismResourceCard from 'organisms/Cards/Resource';

const getFeaturedImage = (post: Resources) => post.featuredImage ?? post.featuredVideoThumbnail ?? undefined;

const ResourceCard: FC<Resources> = post => (
  <OrganismResourceCard
    {...post}
    isDark={false}
    isDarkGradient={post.isDarkGradient || false}
    featuredImage={getFeaturedImage(post)}
    priority={post.priority}
  />
);

export default ResourceCard;
